export default "__VITE_PUBLIC_ASSET__c900bc29__"